import React from "react";
import ReactDOM from "react-dom/client";
import MainRoutes from "./Routes";
import { AuthProvider } from "./AuthContext";
import { ThemeProvider } from "./ThemeContext";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider>
    <AuthProvider>
  <MainRoutes />
    </AuthProvider>
  </ThemeProvider>
);